// extracted by mini-css-extract-plugin
module.exports = {"legal":"az_lfb","headline":"az_mfb"};